function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.184382 4.06165L4.12118 0.182328C4.2445 0.0608282 4.4065 0 4.56834 0C4.72971 0 4.89108 0.0603628 5.0144 0.181242C5.26135 0.423311 5.26182 0.816209 5.0155 1.0589L2.15349 3.87932L11.3684 3.87932C11.7172 3.87932 12 4.15723 12 4.50001C12 4.84279 11.7172 5.1207 11.3684 5.1207L2.15349 5.1207L5.0155 7.94096C5.26182 8.18366 5.26135 8.57671 5.0144 8.81878C4.76745 9.06085 4.3675 9.06038 4.12118 8.81754L0.184382 4.93822C-0.0614605 4.69599 -0.0614605 4.30403 0.184382 4.06165Z",
  fill: "#111111"
});

const SvgArrowThinLeft = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: 12,
  height: 9,
  viewBox: "0 0 12 9",
  fill: "none",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgArrowThinLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-thin-left.901c794e.svg";
export { ForwardRef as ReactComponent };